import { render, staticRenderFns } from "./TableOne.vue?vue&type=template&id=616da0ba&scoped=true&"
import script from "./TableOne.vue?vue&type=script&lang=js&"
export * from "./TableOne.vue?vue&type=script&lang=js&"
import style0 from "./TableOne.vue?vue&type=style&index=0&id=616da0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616da0ba",
  null
  
)

export default component.exports